export const exposeCases = [
  {
    id: "high-yield-app",
    title: "「高收益理财 App」崩盘始末：年化 18% 的糖衣炮弹",
    category: "金融骗局",
    summary:
      "一款看起来有正规备案、还有明星站台的理财 App，用「稳赚不赔」的话术吸引了大量普通用户，直到某天提现按钮变成灰色。我们复盘了它从拉新到崩盘的全过程。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20abstract%20still%20life%20of%20scattered%20financial%20charts%20and%20a%20cracked%20smartphone%20on%20warm%20beige%20paper%20texture%2C%20deep%20vermillion%20accent%20lighting%2C%20dramatic%20side%20shadows%2C%20muted%20ochre%20tones%2C%20investigative%20journalism%20mood%2C%20no%20text%2C%20high%20detail%20composition&width=1200&height=800&seq=expose-one-01&orientation=landscape",
    coverAlt: "散落的理财图表与破碎手机组成的杂志风静物，象征高收益理财骗局",
    date: "2026-08-18",
    heat: 9821,
    readMinutes: 7,
    tags: ["稳赚不赔", "提现困难", "资金盘"],
    loss: "单笔损失多集中在 3 万至 50 万元之间",
    sections: [
      {
        heading: "「天上掉馅饼」是怎么开始的",
        paragraphs: [
          "故事的入口通常很小：一条短视频广告、一个陌生群邀请，或者朋友的一句「我上个月提了两个月工资」。这类平台的第一步永远不是要钱，而是让你先赚一点小钱。",
          "新用户注册后往往能立刻收到几元到几十元的小额返现，提现秒到账。这个阶段的作用只有一个——把「这是真的」这四个字塞进你的判断里。"
        ]
      },
      {
        heading: "套路拆解：四个让人上钩的关键动作",
        paragraphs: [
          "第一是包装。平台会展示看似正式的资质图片、办公场景视频和所谓合作机构，但仔细核对会发现名称与公示信息对不上。第二是分级，投入越多，显示的收益比例越高，用阶梯诱惑逼你加码。",
          "第三是社交压力。群里全天滚动「到账截图」，还有专人扮演老用户分享心得，制造「别人都在赚只有你在犹豫」的氛围。第四是锁定期，一旦你投入较大金额，就会出现「任务未完成」「需要充值解冻」等延迟提现的理由。"
        ]
      },
      {
        heading: "崩盘前的三个信号",
        paragraphs: [
          "信号一：提现开始出现延迟，客服从秒回变成半天不回。信号二：平台突然上线新的高额活动，鼓励短期大额充值。信号三：原本热闹的群开始清理发言、禁止讨论提现问题。",
          "当提现必须靠「继续充值」来解锁时，基本可以判定资金链已经断裂。此时继续投入只会扩大损失，正确的做法是立刻停止转账并保存所有记录。"
        ]
      }
    ],
    checklist: [
      "任何承诺保本高收益的平台，先默认它是骗局",
      "核对资质名称与实际运营主体是否一致",
      "小额提现成功不代表平台安全，那只是诱饵",
      "出现「充值解冻」类要求立即停止投入",
      "保存转账记录、聊天记录与平台截图"
    ]
  },
  {
    id: "brushing-part-time",
    title: "刷单返利兼职：第一天赚 200，第三天赔进 6 万",
    category: "网络诈骗",
    summary:
      "「动动手指日入 300」的兼职广告点进去，往往是一个精心设计的返利游戏。前期小额返现建立信任，后期任务升级吞掉大额本金，这套流程已经高度标准化。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20abstract%20collage%20of%20a%20smartphone%20screen%20glow%20and%20tangled%20paper%20receipts%20on%20warm%20cream%20background%2C%20deep%20red%20and%20ochre%20palette%2C%20moody%20journalism%20lighting%2C%20subtle%20grain%2C%20no%20text%2C%20cinematic%20composition&width=1200&height=800&seq=expose-two-02&orientation=landscape",
    coverAlt: "手机屏幕光与缠绕的纸质回执组成的抽象拼贴，象征刷单返利骗局",
    date: "2026-08-11",
    heat: 8634,
    readMinutes: 6,
    tags: ["兼职诈骗", "返利任务", "垫付本金"],
    loss: "单笔损失常见 5 千至 20 万元",
    sections: [
      {
        heading: "从「简单任务」到「组合任务」",
        paragraphs: [
          "最初的任务确实简单：关注一个账号、点一个赞，就能收到几块钱。这一步没有任何门槛，目的是让你确认「这件事真的给钱」。",
          "接着任务会被包装成「组合单」，需要你先垫付购买金额，完成后本金加佣金一起返还。前一两单一定按时返，等你放心加大金额后，真正的收割才开始。"
        ]
      },
      {
        heading: "为什么明知道不对劲还是转了钱",
        paragraphs: [
          "因为沉没成本。当你已经投进去两万，对方说「再完成最后一单就能全部提现」，大多数人会想「都到这一步了」。骗子正是靠这个人性弱点反复加码。",
          "另一个推手是群聊氛围。群里除了你，其他人可能都是安排好的角色，他们的「到账截图」会持续削弱你的怀疑。"
        ]
      }
    ],
    checklist: [
      "任何需要先垫付资金的兼职都不用考虑",
      "正规平台不会用私人账户收款",
      "被拉进陌生兼职群后直接退出，不要互动",
      "已转账的，停止追加并立即报警",
      "不要因为「马上就能提现」而继续投入"
    ]
  },
  {
    id: "prepaid-card-risk",
    title: "预付卡跑路预警：健身房、理发店、亲子乐园的共同征兆",
    category: "消费维权",
    summary:
      "办卡时热情似火，跑路时人走楼空。预付式消费的风险并不是无迹可寻，多个跑路案例中反复出现了同样的征兆，提前识别能帮你避开大部分损失。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20an%20empty%20shuttered%20storefront%20gate%20with%20faded%20posters%20on%20warm%20beige%20wall%2C%20soft%20afternoon%20light%2C%20ochre%20and%20deep%20red%20accents%2C%20quiet%20melancholy%20mood%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=expose-three-03&orientation=landscape",
    coverAlt: "贴着褪色海报的关闭卷帘门店面，象征预付卡商家跑路",
    date: "2026-07-29",
    heat: 6420,
    readMinutes: 5,
    tags: ["预付卡", "办卡优惠", "退费难"],
    loss: "单张卡损失约 2 千至 3 万元",
    sections: [
      {
        heading: "跑路前的典型动作",
        paragraphs: [
          "第一个动作是大力度促销。原本 5000 元的年卡突然打折到 2000 元，还会叠加「买一年送半年」。商家急着回笼现金时，优惠往往已经超出正常经营逻辑。",
          "第二个动作是员工流动异常。教练、理发师频繁更换，老员工陆续离职，店内开始拖欠供应商货款，这些细节在跑路前通常都能观察到。"
        ]
      },
      {
        heading: "办卡前值得花五分钟做的事",
        paragraphs: [
          "先查经营主体。招牌上的名字和营业执照上的名称经常不是同一个，把主体名称记下来，观察它是否频繁更换。",
          "再控制预付额度。把单次预付金额控制在自己三个月内能用完的范围内，不要为了折扣一次性投入上万。"
        ]
      }
    ],
    checklist: [
      "拒绝超出正常幅度的促销折扣",
      "预付金额不超过三个月消费量",
      "保留合同、发票与支付凭证",
      "发现员工大量离职时尽早申请退费",
      "商家失联后联合其他消费者统一维权"
    ]
  },
  {
    id: "live-bargain-play",
    title: "直播间「全网最低价」是怎么演出来的",
    category: "消费维权",
    summary:
      "限时倒计时、仅剩三件、原价划线再打折——直播间的价格表演有一套完整脚本。看懂这套机制，你就不会再被「错过就亏」的情绪牵着走。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20scene%20of%20a%20ring%20light%20and%20price%20tags%20scattered%20across%20a%20warm%20beige%20surface%2C%20deep%20vermillion%20and%20gold%20ochre%20lighting%2C%20studio%20shadows%2C%20no%20text%2C%20magazine%20investigation%20aesthetic&width=1200&height=800&seq=expose-four-04&orientation=landscape",
    coverAlt: "环形补光灯与散落价格标签组成的抽象画面，象征直播间价格套路",
    date: "2026-07-16",
    heat: 7130,
    readMinutes: 5,
    tags: ["直播带货", "虚假折扣", "冲动消费"],
    loss: "单次多花 30% 至 200% 的冤枉钱",
    sections: [
      {
        heading: "价格锚点是怎么做出来的",
        paragraphs: [
          "直播间最常见的做法是先抬高原价再打折。所谓「原价 899，今天 199」，往往从未以 899 成交过，划线价只是为了让折扣看起来更狠。",
          "另一种是限量表演。后台库存显示还剩很多，主播却反复强调「就剩最后三件」，配合倒计时制造紧迫感，压缩你比价的时间。"
        ]
      },
      {
        heading: "下单前的三个冷静动作",
        paragraphs: [
          "第一，离开直播间，用商品名称在其他平台搜一遍，看看真实价格区间。第二，看评价里的中差评，重点找与宣传不符的描述。",
          "第三，把「现在不买会怎样」想清楚。多数直播间里的商品并不是稀缺品，晚买一天通常什么都不会损失。"
        ]
      }
    ],
    checklist: [
      "不要在倒计时压力下下单",
      "离开直播间再比一次价",
      "重点阅读中差评而不只看好评",
      "截图保存宣传页面以便维权",
      "急需再买，不需要就不买"
    ]
  },
  {
    id: "fake-customer-service",
    title: "假客服退款骗局：一个验证码就能掏空你的账户",
    category: "网络诈骗",
    summary:
      "「您购买的商品存在质量问题，我们为您办理三倍赔付」——接到这类电话时，真正的风险从那句「请提供验证码」开始。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20abstract%20close%20up%20of%20a%20phone%20keypad%20and%20a%20folded%20warranty%20card%20on%20warm%20paper%20background%2C%20deep%20red%20rim%20light%2C%20ochre%20highlights%2C%20moody%20shadow%2C%20no%20text%2C%20cinematic%20still%20life&width=1200&height=800&seq=expose-five-05&orientation=landscape",
    coverAlt: "电话键盘与折叠保修卡的特写抽象图，象征假客服退款骗局",
    date: "2026-07-03",
    heat: 10420,
    readMinutes: 5,
    tags: ["假冒客服", "验证码", "屏幕共享"],
    loss: "单笔损失常见 1 万至 30 万元",
    sections: [
      {
        heading: "骗局的完整剧本",
        paragraphs: [
          "第一步，对方能准确报出你的订单信息，这通常来自信息泄露。第二步，用「三倍赔付」「系统误扣」等理由让你放松警惕。第三步，引导你添加所谓客服账号，脱离官方渠道沟通。",
          "第四步是关键：以「验证账户」「核对额度」为由索要短信验证码，或要求你开启屏幕共享。验证码一旦给出，资金转移就在几秒内完成。"
        ]
      },
      {
        heading: "唯一正确的应对方式",
        paragraphs: [
          "挂断电话，打开购物 App 自己联系官方客服核实。退款永远在原路返回，不需要你提供验证码，也不需要你转账到任何「安全账户」。",
          "如果已经开启了屏幕共享，立刻关闭并退出相关 App，随后检查账户余额与绑定的支付方式。"
        ]
      }
    ],
    checklist: [
      "验证码绝不向任何人透露",
      "拒绝一切屏幕共享请求",
      "挂断后自行通过官方渠道核实",
      "退款只走原路，不需要额外操作",
      "发现异常立即冻结账户并报警"
    ]
  },
  {
    id: "recruit-fee-trap",
    title: "招聘收费陷阱：入职先交「服装费」的都是什么套路",
    category: "职场陷阱",
    summary:
      "正常的招聘流程中，员工不需要向公司交任何费用。一旦出现押金、服装费、培训费、体检押金，基本可以判断这是一场收费游戏。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20an%20empty%20office%20desk%20with%20an%20unsigned%20contract%20and%20a%20stamp%20pad%20on%20warm%20beige%20paper%2C%20deep%20red%20and%20ochre%20accents%2C%20soft%20directional%20lighting%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=expose-six-06&orientation=landscape",
    coverAlt: "空办公桌上未签署的合同与印泥组成的俯拍，象征招聘收费陷阱",
    date: "2026-06-21",
    heat: 4980,
    readMinutes: 5,
    tags: ["招聘收费", "押金", "虚假岗位"],
    loss: "单笔损失 500 至 8000 元",
    sections: [
      {
        heading: "收费的名目一直在变",
        paragraphs: [
          "过去常见的是押金和服装费，现在更多包装成「岗前培训费」「设备押金」「资料费」，甚至通过第三方分期平台办理所谓「技能提升贷款」。",
          "名目在变，逻辑没变：先让你交钱，再让岗位消失。有的公司会把你安排到与承诺完全不符的岗位，逼你自己辞职，从而吃掉押金。"
        ]
      },
      {
        heading: "如何在面试阶段识别",
        paragraphs: [
          "看面试地点。正规公司通常在自有办公场所面试，而收费陷阱常约在咖啡厅、酒店客房或临时租用的隔间。",
          "看信息透明度。岗位描述含糊、公司主体查不到、薪资远高于同岗位水平，同时急着让你当天签约付款，这些都是危险信号。"
        ]
      }
    ],
    checklist: [
      "任何入职前收费的岗位直接放弃",
      "面试地点异常偏僻或临时要警惕",
      "核实招聘主体与营业执照",
      "不签任何分期贷款性质的协议",
      "已交费保留凭证并向平台举报"
    ]
  },
  {
    id: "fake-charity",
    title: "温情众筹的另一面：伪造求助信息的产业链",
    category: "网络诈骗",
    summary:
      "照片催人泪下、文案字字揪心，但收款账户却对不上医院。利用善意的众筹造假，让真正需要帮助的人更难被相信。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20of%20a%20folded%20paper%20crane%20beside%20a%20blurred%20donation%20box%20on%20warm%20cream%20paper%2C%20deep%20red%20and%20soft%20ochre%20tones%2C%20quiet%20lighting%2C%20no%20text%2C%20magazine%20style&width=1200&height=800&seq=expose-seven-07&orientation=landscape",
    coverAlt: "折纸鹤与虚化捐款箱组成的抽象画面，象征伪造众筹信息",
    date: "2026-06-09",
    heat: 5310,
    readMinutes: 4,
    tags: ["众筹造假", "善意被利用", "信息核实"],
    loss: "每笔捐赠 20 至 500 元不等",
    sections: [
      {
        heading: "造假链条是怎么运转的",
        paragraphs: [
          "素材可以购买，病历可以套用模板，故事可以批量改写。有人在社交平台批量发布求助信息，同时准备多个收款二维码，收到款项后立即转移。",
          "这类信息的共同特征是：缺少可核实的就诊信息，只留下个人收款方式，并不断催促「尽快转发」。"
        ]
      },
      {
        heading: "献爱心之前的核实步骤",
        paragraphs: [
          "优先选择有资质、有公示流程的正规平台，善款进入平台账户而非个人账户。核实求助信息中的医疗机构名称与科室是否真实存在。",
          "对于只在私聊和群聊中传播、没有任何公示信息的求助，宁可暂缓，也可以通过官方平台寻找同一事件的合规募捐入口。"
        ]
      }
    ],
    checklist: [
      "通过正规平台捐赠，不向个人账户转账",
      "核实求助信息中的医疗机构信息",
      "警惕只催转发却不提供细节的求助",
      "保留转账记录以便追溯",
      "发现造假及时向平台举报"
    ]
  },
  {
    id: "elder-health-sale",
    title: "老年保健品会销：免费鸡蛋背后的完整话术脚本",
    category: "行业黑幕",
    summary:
      "免费领鸡蛋、免费测血压、免费听讲座，这些看似温暖的日常，往往是一次精心设计的高价推销开场。我们把常见话术拆开来看。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20a%20paper%20cup%20and%20a%20small%20bottle%20of%20supplement%20on%20a%20warm%20beige%20table%20with%20soft%20window%20light%2C%20ochre%20and%20deep%20red%20tones%2C%20gentle%20shadows%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=expose-eight-08&orientation=landscape",
    coverAlt: "纸杯与小瓶装保健品放在米色桌面上的静物，象征老年保健品会销",
    date: "2026-05-27",
    heat: 7760,
    readMinutes: 6,
    tags: ["保健品", "会销", "关爱话术"],
    loss: "单次支出 3 千至 10 万元",
    sections: [
      {
        heading: "从送鸡蛋到喊爸妈",
        paragraphs: [
          "会销的前三天几乎不提钱。工作人员嘘寒问暖，帮老人量血压、送小礼品、组织唱歌，逐步建立起比子女还亲密的信任感。",
          "第四天开始出现「专家」，用一堆听不懂的术语强调「再不吃就晚了」，配合其他参与者现身说法，把保健品描述成救命稻草。"
        ]
      },
      {
        heading: "为什么长辈很难拒绝",
        paragraphs: [
          "一方面是对健康的真实焦虑，另一方面是情感需求。推销员提供的陪伴和关注，填补了很多长辈日常的孤独，拒绝购买会让他们觉得辜负了这份关心。",
          "因此单纯指责往往适得其反。更有效的方式是增加日常陪伴，并提前和长辈约定「超过一定金额的消费先跟家人商量」。"
        ]
      }
    ],
    checklist: [
      "提醒长辈保健品不能替代药品治疗",
      "约定大额消费需家人知情",
      "警惕免费讲座背后的高价推销",
      "留存购买凭证与宣传材料",
      "发现虚假宣传及时投诉举报"
    ]
  },
  {
    id: "second-hand-off-platform",
    title: "二手交易「低价捡漏」：脱离平台交易的那一刻就输了",
    category: "消费维权",
    summary:
      "「平台抽成太高，我们私下交易给你便宜 300」——这句话说完，你手里就只剩下一笔无法追溯的转账记录。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20abstract%20of%20a%20phone%20package%20box%20and%20loose%20bubble%20wrap%20on%20warm%20beige%20paper%20surface%2C%20deep%20vermillion%20and%20ochre%20accents%2C%20soft%20studio%20shadows%2C%20no%20text%2C%20high%20detail%20composition&width=1200&height=800&seq=expose-nine-09&orientation=landscape",
    coverAlt: "手机包装盒与散落气泡膜组成的抽象画面，象征二手交易私下转账风险",
    date: "2026-05-14",
    heat: 6110,
    readMinutes: 4,
    tags: ["二手交易", "脱离平台", "私下转账"],
    loss: "单笔损失 200 至 1.5 万元",
    sections: [
      {
        heading: "脱离平台的三种理由",
        paragraphs: [
          "理由一：平台抽成高，私下更便宜。理由二：走平台太慢，直接转账今天就发货。理由三：先付定金锁定商品，到货再付尾款。",
          "这三种说法看似为你省钱省时间，实际都是在切断平台对你的保护。一旦转账，对方拉黑你，平台也无法介入处理。"
        ]
      },
      {
        heading: "降低风险的交易习惯",
        paragraphs: [
          "坚持平台内交易，保留完整的订单与聊天记录。收到货后当场验机、验货，确认无误再确认收货。",
          "对于明显低于市场价的商品，先问自己：为什么对方愿意亏本卖？多数的「低价捡漏」最终都以收到假货或劣质品收场。"
        ]
      }
    ],
    checklist: [
      "坚持在平台内完成交易与支付",
      "拒绝一切私下转账与扫码付款",
      "收件时当场验货并拍摄开箱视频",
      "价格明显异常时提高警惕",
      "保留完整聊天记录以备维权"
    ]
  },
  {
    id: "training-loan",
    title: "培训贷陷阱：包就业承诺背后的分期合同",
    category: "职场陷阱",
    summary:
      "「先培训后付款、包就业、不满意退费」听起来几乎零风险，但很多学员在签字的那一刻，就背上了几万元的培训贷款。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20a%20thick%20training%20brochure%20and%20a%20pen%20on%20warm%20beige%20desk%2C%20deep%20red%20and%20ochre%20tones%2C%20soft%20morning%20light%2C%20subtle%20shadows%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=expose-ten-10&orientation=landscape",
    coverAlt: "厚宣传册与钢笔放在米色桌上的俯拍，象征培训贷陷阱",
    date: "2026-04-30",
    heat: 4520,
    readMinutes: 5,
    tags: ["培训贷", "包就业", "分期合同"],
    loss: "单笔负债 1 万至 5 万元",
    sections: [
      {
        heading: "「先学后付」的真实面目",
        paragraphs: [
          "所谓先学后付，实质是让学员在第三方平台签署分期贷款协议。学费已经一次性打给机构，学员从签约当天起就要按月还款，与是否就业无关。",
          "机构承诺的「包就业」通常写得很模糊，实际推荐的多是低收入或与培训无关的岗位，学员无法胜任或主动离职后，贷款仍需自己偿还。"
        ]
      },
      {
        heading: "签字之前必须确认的三件事",
        paragraphs: [
          "第一，签的到底是什么文件？如果出现「分期服务协议」「贷款合同」字样，就与你理解的学费分期不是一回事。第二，退费条款是否写进合同，口头承诺一律不算数。",
          "第三，就业承诺是否具体。写清岗位类型、薪资区间、推荐次数和未达成的处理方式，才算有约束力的承诺。"
        ]
      }
    ],
    checklist: [
      "拒绝签署任何以个人名义的分期贷款",
      "要求把退费与就业承诺写进合同",
      "查询机构过往学员的真实评价",
      "保留宣传材料作为证据",
      "已签约的尽快咨询退费与解约方式"
    ]
  }
];

export const exposeCategories = [
  "全部",
  "金融骗局",
  "网络诈骗",
  "消费维权",
  "行业黑幕",
  "职场陷阱"
];